<template>
  <div>
    <MenuDocument/>
    <Return_product_waitupdate/>
  </div>
</template>

<script>
import MenuDocument from "@/components/admin/document_stock/menudocument/MenuDocument";
import Return_product_waitupdate from "@/components/admin/document_stock/Return_product_waitupdate";
export default {
  name: "ReturnProductReceipt",
  components: {
    Return_product_waitupdate,
    MenuDocument
  }
}
</script>

<style scoped>

</style>
